import React from 'react';
import { useAuth0Data } from '../../context/Auth0DataContext';
import useSessionMonitor from '../../hooks/useSessionMonitor';
import SessionTimeoutWarning from './SessionTimeoutWarning';

/**
 * Component that monitors user session and shows timeout warning
 * Must be rendered inside Auth0DataProvider
 */
const SessionMonitor = ({ children }) => {
  const { isAuthenticated, refreshToken, signOut } = useAuth0Data();

  const {
    showWarning,
    formattedTimeRemaining,
    extendSession,
  } = useSessionMonitor({
    onRefreshToken: refreshToken,
    onLogout: signOut,
    isAuthenticated,
  });

  return (
    <>
      {children}
      <SessionTimeoutWarning
        isOpen={showWarning}
        timeRemaining={formattedTimeRemaining}
        onExtendSession={extendSession}
        onLogout={signOut}
      />
    </>
  );
};

export default SessionMonitor;
